import { Providers } from 'modules/SlotsRoot/types/configuration'
import { ISlotConverter } from 'modules/SlotsRoot/types/converter'
import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'
import {
  IUpgamingAuthDTO,
  IUpgamingDTO,
  IUpgamingExtraData,
  IUpgamingGameDTO,
} from 'modules/SlotsRoot/types/interfaces/Slots/Upgaming'

interface IConvertGameUrlArgs {
  extraData: IUpgamingExtraData
  gameId: string
  lang: string
  gameList: ISlotViewItem[]
  params: {
    isDesktop: boolean
  }
}
class UpgamingConverter implements ISlotConverter {
  convertGameList = ({
    data,
    platform,
  }: {
    data: IUpgamingDTO
    platform?: 'desktop' | 'mobile' | undefined
  }): ISlotViewItem[] | [] =>
    data.map((item: IUpgamingGameDTO) => ({
      id: `${item.id}`,
      gameId: `upgaming_${item.id}`,
      description: '',
      gameName: item.id.charAt(0).toUpperCase() + item.id.slice(1),
      tab: [],
      tabLive: [],
      provider: 'upgaming',
      imageUrl: item.icon,
      routeProvider: Providers['028142ca'],
    }))

  convertAuthData = (data: IUpgamingAuthDTO): IUpgamingExtraData => ({
    token: data.token,
    projectName: data.brand,
  })

  convertGameUrl = ({ extraData, gameId, gameList, lang, params }: IConvertGameUrlArgs) => {
    const id = gameList.find(t => t.gameId === gameId)?.id

    // eslint-disable-next-line max-len
    return `https://games.upgaming.com/games/${id}/?companyName=${extraData.projectName}&integration=public&token=${extraData.token}`
  }
}

export default UpgamingConverter
